import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CanvasOverlay } from "./canvas-overlay";
import * as Styled from "./cup-technology-indicator.style";
import { cupTechnologyColors } from "api/tacton/constants";
export var CupTechnologyIndicator = function (_a) {
    var _b;
    var anchorX = _a.anchorX, anchorY = _a.anchorY, cupTechnology = _a.cupTechnology;
    return (_jsx(CanvasOverlay, { x: anchorX, y: anchorY, children: _jsx(Styled.CupTechnologyIndicator, { color: cupTechnologyColors[((_b = cupTechnology.color) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) || "none"], children: _jsx(Styled.Label, { title: cupTechnology.code
                    ? "".concat(cupTechnology.code, " - ").concat(cupTechnology.label)
                    : cupTechnology.label, children: cupTechnology.code }) }) }));
};
